export const getTrialRemainder = (expiry) => {
  const expiryDate = new Date(expiry); // this will be null and create a 1970 date for accounts created before the trial expiry field was created
  const now = new Date();
  now.setUTCHours(0, 0, 0, 0);
  const difference = Math.round((expiryDate - now) / (1000 * 60 * 60 * 24));
  return difference;
};
